module.exports = __webpack_public_path__ + "img/spitter-attack-mask-2.88883fdf.png";